<template>
  <img id="navbar-logo" src="@/assets/img/logo-outline.svg" alt="" @click="goToHome">
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import paths from '@/router/paths';

export default defineComponent({
  name: 'NavbarLogo',
  setup() {
    const router = useRouter();

    const goToHome = () => {
      router.push(paths.home);
    };

    return {
      goToHome
    };
  }
});
</script>
<style scoped>
#navbar-logo {
  width: 25px;
  cursor: pointer;
}
</style>
